import React from 'react';

import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';

import scss from './SelectedOptionsList.module.scss';

function SelectedOptionsList({ selectedOptions, onRemoveOption }) {
  if (!selectedOptions.length) {
    return null;
  }

  return (
    <ul className={scss.list}>
      {selectedOptions.map(({ label, value }) => (
        <li key={label} className={scss.item}>
          {label}
          <Icon
            icon={ICONS.Cross}
            disableCommonStyles
            disableCommonColors
            className={scss.icon}
            onClick={() => onRemoveOption(value)}
          />
        </li>
      ))}
    </ul>
  );
}

export default SelectedOptionsList;
